export interface FlexibleSelectData {
    label?: React.ReactNode;
    value?: string;
    /** 回填到Input中的文本 */
    inputText?: string;
}

export enum SelectType {
    ORDER_ITEM_TITLE = "ORDER_ITEM_TITLE",
    ORDER_ITEM_EXTERNAL_ID = "ORDER_ITEM_EXTERNAL_ID",
    SKU_PROPERTIES = "SKU_PROPERTIES",
}

export interface FlexibleSelectProps {
    data: FlexibleSelectData[];
    onFocus?;
    onSearch?: (text: string) => void;
    onChange?(inputValue: string, singleValue: string, multipleValues: string[]): void;
    /** 手动输入的值（非点击选项） */
    inputValue: string;
    /** 单选模式下,选中的值 */
    singleValue: string;
    /** 多选模式下，选中的值 */
    multipleValue?: string[];
    onClear?: () => void;
    /** 数据Key映射回填文本(data是会随着输入的改变而改变，此Map不会) */
    inputTextMap: Map<string, FlexibleSelectData["inputText"]>;
    shopId: number;
    itemHeight?: number;
    className?: string;
    type: SelectType;
    searchText: string;

    defaultMultiple?: boolean;
    onMultipleChange: (checked: boolean) => void;

    isSelectAll: boolean;
    isIndeterminate: boolean;
    onSelectAllChange: (checked: boolean) => void;

    needSimpleTitle?: boolean;
    onSimpleTitleChange?: (checked: boolean) => void;

    needSkuSimpleTitle?: boolean;
    onSkuSimpleTitleChange?: (checked: boolean) => void;

    enabledTopSellingProductPrinting?: boolean;
    onEnabledTopSellingProductPrintingChange?: (checked: boolean) => void;

    showTitlePic?: boolean;
    onShowTitlePicChange?: (checked: boolean) => void;
}

export interface FlexibleSelectListProps {
    type: SelectType;
    data: FlexibleSelectData[];
    onChange?: (data: FlexibleSelectData, checked: boolean, index: number) => void;
    onSearch?: (text: string) => void;
    multipleValue?: string[];
    shopId: number;
    itemHeight?: number;
    className?: string;
    preventComputed: boolean;
    onPreventComputed: () => void;
    searchText: string;

    /** 是否多选 */
    multiple: boolean;
    onMultipleChange: (checked: boolean) => void;

    isSelectAll: boolean;
    isIndeterminate: boolean;
    onSelectAllChange: (checked: boolean) => void;

    needSimpleTitle?: boolean;
    onSimpleTitleChange?: (checked: boolean) => void;
    needSkuSimpleTitle?: boolean;
    onSkuSimpleTitleChange?: (checked: boolean) => void;

    enabledTopSellingProductPrinting?: boolean;
    onEnabledTopSellingProductPrintingChange?: (checked: boolean) => void;

    onOpenChange: (open: boolean) => void;

    showTitlePic?: boolean;
    onShowTitlePicChange?: (checked: boolean) => void;
}

export interface FlexibleSelectHeaderProps {
    multiple: boolean;
    isSelectAll: boolean;
    isIndeterminate: boolean;
    onSelectAllChange: (checked: boolean) => void;
    onPreventComputed: () => void;
    onSearch: (text: string) => void;
    searchText: string;
    data: FlexibleSelectData[];
    multipleValue?: string[];
}

export interface FlexibleSelectFooterProps {
    type: SelectType;
    multiple: boolean;
    onMultipleChange: (checked: boolean) => void;
    shopId: number;
    onSimpleTitleChange?: (checked: boolean) => void;
    needSimpleTitle: boolean;
    enabledTopSellingProductPrinting: boolean;
    onEnabledTopSellingProductPrintingChange?: (checked: boolean) => void;
    needSkuSimpleTitle?: boolean;
    onSkuSimpleTitleChange?: (checked: boolean) => void;
    showTitlePic?: boolean;
    onShowTitlePicChange?: (checked: boolean) => void;
}
